<template>
  <div class="container">
    <div class="help-title">
      <span>{{ $t("help.registrationTitle") }}</span>
    </div>
    <div class="guide-container shadow">
      <div>
        <!-- <div class="help-title">
          <span>{{ $t("help.registrationInfo") }}</span>
        </div> -->
        <div class="help-info">
          <!-- <img src="../../assets/help-icon-05.png" /> -->
          <img src="../../assets/help-icon-06.png" />
          <!-- <span>{{ $t("help.registrationStep") }}</span> -->
          <i18n path="help.registrationStep" tag="span">
            <template v-slot:link>
              <a target="_blank" :href="removeDoubleSlashesFromUrl(adminDomain + '/register-supplier')">eVoucher</a>
            </template>
          </i18n>
        </div>
        <div v-if="company_hotline" class="help-info">
          <img src="../../assets/help-icon-02.png" />
          <i18n path="help.registrationHotline" tag="span">
            <template v-slot:link>
              <!-- <a :href="`tel:${company.hotline}`">company.hotline</a> -->
              <a :href="`tel:${company_hotline}`">{{ company_hotline }}</a>
            </template>
          </i18n>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import stringUtils from 'Utils/stringUtils'
import functionUtils from 'Utils/functionUtils'
export default {
  data: () => ({
    currentDomain: stringUtils.DOMAIN_BASE_PATH,
    adminDomain: process.env.VUE_APP_ADMIN_URL,
    objectSettingKey: stringUtils.ObjectSettingKey,
    company_hotline: null,
  }),
  created() {
    let filter = {
      params: {
        key: this.objectSettingKey.COMPANY_HOTLINE
      }
    }
    this.GET_OBJECT_SETTING(filter)
  },
  watch: {
    OBJECT_SETTING_DATA() {
      let data = this.OBJECT_SETTING_DATA
      let hotlineSettingData = data.filter(element => {
        return element.key === this.objectSettingKey.COMPANY_HOTLINE
      })
      if (hotlineSettingData.length > 0) {
        this.company_hotline = hotlineSettingData[0].value
      }
    }
  },
  computed: {
    ...mapGetters(["OBJECT_SETTING_DATA"]),
  },
  methods: {
    /**
     * Remove double slashes from url
     */
    removeDoubleSlashesFromUrl: function (url) {
        return functionUtils.removeDoubleSlashesFromUrl(url)
    },
    ...mapActions(["GET_OBJECT_SETTING"])
  }
}
</script>

<style lang="scss" scoped>
@import "./help-page.scss";
</style>
